import React, { FC, useCallback, MouseEvent } from 'react';
import { FormattedMessage } from 'react-intl';
import { isTouchDevice } from '../../../utils/domUtils';
import { Hyperlink } from '../../../components/Hyperlink';
import { useRestrictedModal } from '../../../components/modal/useRestrictedModal';
import styles from './commentary_summary.module.scss';
import { useUser } from '../../../user/useUser';
import { CommentaryBase } from '../../commentary.types';
import { getCommentaryUrl } from '../../commentaryUtils';
import { trackCommentary } from '../../commentary.api';

type Props = {
  commentary: CommentaryBase;
  onClick: () => void;
  source: string;
  position: number;
};

export const CommentarySummary: FC<Props> = ({
  commentary,
  source,
  onClick,
  position,
}) => {
  const { accessPremium } = useUser();
  const { openRestrictedModal } = useRestrictedModal();

  const commentarySummaryClicked = useCallback(
    (evt: MouseEvent<HTMLAnchorElement>) => {
      if (!accessPremium) {
        evt.preventDefault();
        openRestrictedModal({ source });
      } else {
        trackCommentary(commentary.url, source, {
          position,
          doc_id: commentary.referenceCommentaryId,
        });
        onClick();
      }
    },
    [accessPremium, commentary],
  );

  const commentaryUrl = getCommentaryUrl(commentary.url, accessPremium, source);

  return (
    <div className={styles.wrapper}>
      {!isTouchDevice() && (
        <p
          className={styles.content}
          dangerouslySetInnerHTML={{ __html: commentary.textShort }}
        />
      )}
      {isTouchDevice() && (
        <Hyperlink
          {...(accessPremium ? { href: commentaryUrl, target: '_blank' } : {})}
          onClick={commentarySummaryClicked}
          className={styles.content}
          dangerouslySetInnerHTML={{ __html: commentary.textShort }}
        />
      )}
      <Hyperlink
        className={styles.more}
        onClick={commentarySummaryClicked}
        {...(accessPremium ? { href: commentaryUrl, target: '_blank' } : {})}
      >
        {'\u00A0'}
        <FormattedMessage id="CommentarySummary.tsx/1" />
      </Hyperlink>
    </div>
  );
};
